import React from 'react';
import { Link, useLocation } from 'react-router-dom';

interface LocationState {
  title?: string;
}

const SubmitConfirmation: React.FC = () => {
  const location = useLocation();
  const state = location.state as LocationState;
  const hackTitle = state?.title || '';

  return (
    <div className="min-h-screen flex flex-col">
      <main className="flex-grow container mx-auto px-4 py-12">
        <div className="max-w-2xl mx-auto bg-white shadow-md rounded-lg text-center p-6">
          <div className="mb-8">
            <div className="w-16 h-16 bg-green-100 text-green-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            
            <h1 className="text-2xl font-bold text-green-600 mb-4">
              Thank You for Your Submission!
            </h1>
            
            {hackTitle && (
              <p className="text-lg font-medium mb-2">"{hackTitle}"</p>
            )}
            
            <p className="text-gray-600 mb-4">
              Your accessibility hack has been submitted successfully and is pending review.
              Our editorial team will review your submission shortly.
            </p>
            
            <div className="bg-yellow-50 p-4 rounded-md text-left mb-4">
              <h3 className="text-yellow-800 font-medium mb-2">What happens next?</h3>
              <ul className="text-yellow-700 list-disc pl-5 space-y-1">
                <li>Our team reviews all submissions for quality and relevance</li>
                <li>If approved, your hack will be published on the platform</li>
                <li>We may contact you if any clarification is needed</li>
              </ul>
            </div>
          </div>
          
          <div className="space-y-4">
            <Link
              to="/browse"
              className="block w-full bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            >
              Browse Other Hacks
            </Link>
            <Link
              to="/submit"
              className="block w-full bg-green-600 text-white py-2 px-4 rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
            >
              Submit Another Hack
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
};

export default SubmitConfirmation; 